import { render, staticRenderFns } from "./ImageSwiper.vue?vue&type=template&id=d4a6d0fa&scoped=true&"
import script from "./ImageSwiper.vue?vue&type=script&lang=js&"
export * from "./ImageSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ImageSwiper.vue?vue&type=style&index=0&id=d4a6d0fa&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a6d0fa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SwiperNav: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/swiper-nav/SwiperNav.vue').default})
